import * as React from 'react'

function SvgIconResearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="research" aria-labelledby="t-research d-research">
        <title id="t-research">{'Reseach'}</title>
        <desc id="d-research">{'An optical microscope'}</desc>
        <path d="M26.9 7.8l-1.4-1.4L29 2.8 26.2 0l-3.5 3.5-1.4-1.4-11.1 11.1c-.5.5-.9 1.2-1 1.8H7c-.5 0-1 .5-1 1s.5 1 1 1h2.1c.1.4.2.7.4 1L8 19.5c-.4.4-.4 1 0 1.4.4.396 1 .396 1.4 0l1.5-1.5c.3.199.7.3 1 .396V22c0 .5.5 1 1 1s1-.5 1-1v-2.1c.7-.2 1.3-.5 1.8-1l3.1-3.104c.3.2.7.3 1 .3.7 0 1.3-.3 1.601-.8.699 3.104 1.104 6.399 1.312 9.804H7c-.3 0-.5.196-.5.5 0 .3.2.4.5.4h16v2H4c-.5 0-1 .5-1 1v2c0 .5.5 1 1 1h24c.5 0 1-.5 1-1 0-7.6-2-14.5-5.3-20l3.2-3.2zm-.7-6.4l1.4 1.4-2.8 2.8-1.4-1.4 2.8-2.8zM10.9 18.1c-1.2-1.199-1.2-3.1 0-4.2l4.2 4.2c-1.1 1.2-3.1 1.2-4.2 0zM20 15c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-2.7c-.3-.2-.6-.3-1-.3-1.1 0-2 .9-2 2 0 .4.1.7.3 1l-2.4 2.4-4.2-4.2 9.6-9.6 4.2 4.2-4.5 4.5zM28 31H4v-2h19c.6 0 1-.4 1-1 0-5.4-.7-10.7-1.9-15.4l.9-.9c3.2 5.5 5 12.3 5 19.3z" />
      </g>
    </svg>
  )
}

export default SvgIconResearch
